import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../data/data.service';
import { GeneratedArtifactMeta } from '../data/artifact';
import { ActivatedRoute } from '@angular/router';
import { Course } from '../data/course';
import { CourseOrActivity } from '../data/course-or-activity-artifact';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-recent-artifacts',
  templateUrl: './recent-artifacts.component.html',
  styleUrls: ['./recent-artifacts.component.scss']
})
export class RecentArtifactsComponent implements OnInit {
  constructor(
    private dataService: DataService, 
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  @Input() courses: Course[];
  @Input() defaultCourseCode: string;

  selectedCourseOrActivityCode: string;
  studentID: number;
  isLoading: boolean = false;
  isInternalUser = this.authService.isInternal();
  allArtifactsLoaded: boolean = false;
  courseOrActivitys: CourseOrActivity[]=[];
  selectedCourseArtifacts: GeneratedArtifactMeta[];

  artifactsPerLoad: number = 24;

  ngOnInit(): void {

    this.selectedCourseOrActivityCode = this.defaultCourseCode || "Y4-EFL";
    this.courses.forEach(course => {
      let courseElement = new CourseOrActivity;
      courseElement.Course = course;
      courseElement.isCourse = true;
      this.courseOrActivitys.push(courseElement)
    });
    // May need to add a list of activites like future DC and KadyChain to backend or just hard code it -braden
    let activityElementDaisy = new CourseOrActivity;
    activityElementDaisy.ActivityName = "DaisyChain";
    activityElementDaisy.isCourse = false;
    this.courseOrActivitys.push(activityElementDaisy);
    let activityElementKady = new CourseOrActivity;
    activityElementKady.ActivityName = "KadyChain";
    activityElementKady.isCourse = false;
    this.courseOrActivitys.push(activityElementKady);
    this.isLoading = true;
    this.route.params.subscribe(params => this.studentID = params.studentId);
    this.changeCourse(this.selectedCourseOrActivityCode);
  }

  changeCourse(selectedCourseOrActivityCode :string) {
   let selectedCourseorActivity = this.courseOrActivitys.find(x=>(x.isCourse && x.Course.Code == this.selectedCourseOrActivityCode)
   ||(!x.isCourse && x.ActivityName == this.selectedCourseOrActivityCode));
    if(selectedCourseorActivity.isCourse)
    {
      this.selectedCourseArtifacts = [];
      this.allArtifactsLoaded = false;
      this.loadArtifacts();
    }
  }

  loadArtifacts() {
    if (!this.selectedCourseArtifacts) this.selectedCourseArtifacts = [];
    let skip = this.selectedCourseArtifacts.length;
    this.isLoading = true;
    // Load 1 extra artifact so we can check if we've reached the end
    this.dataService.getRecentArtifactsMeta(this.studentID, this.selectedCourseOrActivityCode, this.artifactsPerLoad + 1, skip).subscribe(result => {
      this.isLoading = false;
      if (!result || result.length === undefined) {
        console.error("Something went wrong retrieving the student work");
        return;
      }

      if (result.length < 25) this.allArtifactsLoaded = true;
      else result.pop();

      this.selectedCourseArtifacts.push(...result);
    });
  }
}
